module.exports = __webpack_public_path__ + "static/media/logo_demo.8bfd3a8e.png";